import Swal from "sweetalert2";
import i18n from "../../i18n";

const tSg = (key: string) => i18n.t(key, { ns: "sg" }) as string;

export function notifyOk(text?: string) {
  return Swal.fire({
    icon: "success",
    title: tSg("notify.savedTitle"),
    text: text ?? tSg("notify.savedText"),
    timer: 1800,
    showConfirmButton: false,
    timerProgressBar: true,
  });
}

export function notifyLoading(title?: string) {
  return Swal.fire({
    title: title ?? tSg("notify.processingTitle"),
    text: tSg("notify.processingText"),
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading(),
  });
}

export function notifyError(text?: string) {
  return Swal.fire({
    icon: "error",
    title: tSg("notify.errorTitle"),
    text: text ?? tSg("notify.errorText"),
    confirmButtonColor: "#2563eb",
  });
}

export function confirmAction({
  title,
  text,
  confirmText,
}: { title?: string; text?: string; confirmText?: string } = {}) {
  return Swal.fire({
    icon: "warning",
    title: title ?? tSg("notify.confirmTitle"),
    text: text ?? tSg("common.confirmText"),
    showCancelButton: true,
    confirmButtonText: confirmText ?? tSg("notify.confirmDefault"),
    cancelButtonText: tSg("notify.cancel"),
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
  }).then((r) => r.isConfirmed);
}
